import { gql } from "@apollo/client";
import { TOPIC_ADDITIONAL_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

// NOTE: there can be partial validation errors (which we ignore) when booking all classes in a course
const BOOK_COURSE = gql`
  mutation BookCourse($courseId: ID!) {
    bookCourse(input: { courseId: $courseId }) {
      appointments {
        bookedClass {
          id
          date
          time
          startTime
          endHour24hr
          classType
          classSize
          seatsRemaining
          category
          teacher {
            id
            avatar
            givenName
            familyName
          }
          topic {
            ...TopicAdditionalFields
          }
          city {
            id
            name
          }
          level {
            title
          }
          chapter {
            name
          }
          participants {
            id
            name
            avatar
          }
        }
        bookedAt
        status
      }
      errors
    }
  }
  ${TOPIC_ADDITIONAL_FIELDS_FRAGMENT}
`;

export default BOOK_COURSE;
